module.exports = __webpack_public_path__ + "images/161d2b9f68ee19264c5dd6403da2f9c1-logo_white.png";